import styled from "styled-components";
import tw from "tailwind-styled-components";

export const CardsFlexibleItemWrapper = tw.div`
  flex
  flex-col
  justify-between
  items-center
  gap-6
  py-8
  px-6
  bg-gray-100
  rounded-2xl
`;

export const InformationWrapper = tw.div`
  flex
  flex-col
  items-center
  gap-6
`;

export const ImageWrapper = tw.div`
  w-10 desktop:w-11
  h-10 desktop:h-11
`;

export const Title = tw.div`
  font-medium
  text-2xl
  text-center
`;

export const EditorWrapper = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  p {
    margin: 0;
  }

  @media screen and (min-width: 1128px) {
    font-size: 18px;
    line-height: 28px;
  }
`;

export const ButtonWrapper = tw.div`
  w-full
`;
